import { render, staticRenderFns } from "./AlternativeProduct.vue?vue&type=template&id=02316216"
import script from "./AlternativeProduct.vue?vue&type=script&lang=js"
export * from "./AlternativeProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports